import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { KanbanSelectionService } from '@shared/services/kanban-selection.service';
import { FormBuilder } from '@angular/forms';
import { SortingField } from '../types';
import { PreOrder } from '../../../types/pre-order';

@Injectable({
  providedIn: 'root',
})
export class CommonStateService extends KanbanSelectionService<PreOrder> {
  selectedSortingFields$ = new BehaviorSubject<SortingField[]>([]);
  trailerType$ = new BehaviorSubject<Nullable<string>>(null);

  weekNumber = this.fb.control<Nullable<number>>(null);
  refresh$ = new Subject<void>();
  constructor(private readonly fb: FormBuilder) {
    super();
  }

  selectSortingField(field: SortingField) {
    const ids = this.selectedSortingFields$.value.map(field => field.value);
    if (ids.includes(field.value)) {
      const filtered = this.selectedSortingFields$.value.filter(
        f => f.value !== field.value,
      );
      this.selectedSortingFields$.next(filtered);
    } else {
      this.selectedSortingFields$.next([
        ...this.selectedSortingFields$.value,
        field,
      ]);
    }
  }
}
